import { API_BASE_URL } from '@synergy/config';
import { PaginatedResponse } from '@synergy/api';
import { createAction } from '@reduxjs/toolkit';

import { AppDispatch } from '../../store/store';
import { NewsApi } from './../api/news-api';
import { NewsPostDto } from '../models/dto/news-post-dto';
import { notFoundError } from './feedback-actions';

const api = new NewsApi(API_BASE_URL);

export const newsReceived = createAction<PaginatedResponse<NewsPostDto>>('news/loaded');
export const newsSliderItemsReceived = createAction<PaginatedResponse<NewsPostDto>>('news/slider-items-loaded');
export const newsDetailReceived = createAction<NewsPostDto>('news/detail-loaded');

export const fetchNews = (searchParams?: URLSearchParams) => async (dispatch: AppDispatch) => {
    const response = await api.getNews(searchParams);
    if (response.success) {
        dispatch(newsReceived(response.result));
    }
    // We don't show an error if failed - just don't display the news
};

export const fetchNewsSliderItems = (searchParams?: URLSearchParams) => async (dispatch: AppDispatch) => {
    const response = await api.getNews(searchParams);
    if (response.success) {
        dispatch(newsSliderItemsReceived(response.result));
    }
    // We don't show an error if failed - just don't display the news
};

export const fetchNewsDetail = (id: number) => async (dispatch: AppDispatch) => {
    const response = await api.getNewsDetails(id);
    if (response.success) {
        dispatch(newsDetailReceived(response.result));
    } else {
        dispatch(notFoundError());
    }
};
